import React, { memo, useState, useEffect } from 'react';
import { Input, Form } from 'antd';
import { useSelector, useDispatch } from 'react-redux';

import actions from '@flux/action';
import InsightTextarea from '../insightTextarea';
import { insightModals } from '@model';
import { Button } from 'appkit-react';

import { splitCamelCaseString } from '@utils/widget';

function InsightForm(props) {
  const {
    currentDetail = {},
    isEdit,
    from = '',
    category,
    uuid,
    segment,
    isActionLoading: isLoading,
    field = 'insight',
    companyInstance,
  } = props;
  const { changeConfig, closeModal, toggleActionLoading } = props;
  const defaultValue = isEdit ? currentDetail : {};
  const [canSubmit, setCanSubmit] = useState(false);
  const [insightForm] = Form.useForm();
  const projectId = useSelector((state) => state.common.currentId);
  const dispatch = useDispatch();

  const shouldHideSummaryIfIsGuidingP = field === 'guidingPrinciple';

  const moduleName = splitCamelCaseString(field);

  const handleCancel = ({ needCallModalCallback = false }) => {
    if (from) {
      changeConfig({
        type: from,
      });
    } else {
      closeModal(needCallModalCallback);
    }
  };
  const handleEditFinish = (formData) => {
    if (isEdit && from !== '') {
      changeConfig({
        type: from,
        currentDetail: {
          ...currentDetail,
          ...formData,
        },
      });
    } else {
      handleCancel({ needCallModalCallback: true });
    }
  };
  const submitForm = async () => {
    const value = await insightForm.validateFields();
    for (const k in value) {
      value[k]?.trim()?.length === 0 && (value[k] = value[k].trim());
    }
    const urlSuffix =
      field === 'guidingPrinciple' && companyInstance
        ? `?type=${companyInstance}`
        : '';
    toggleActionLoading(true);
    const result = await dispatch(
      actions.handleInsightModalSave({
        insightId: currentDetail.insightId,
        companyInstance,
        category,
        uuid,
        segment,
        isEdit,
        projectId,
        field,
        urlSuffix,
        ...value,
      }),
    );
    toggleActionLoading(false);

    if (result?.success) {
      handleEditFinish(value);
    }
  };

  const onFormChange = () => {
    const canSubmit =
      Object.values(insightForm.getFieldsValue()).filter((v) => v && v.trim())
        .length === 0;
    setCanSubmit(canSubmit);
  };

  useEffect(() => {
    Object.keys(defaultValue).length === 0
      ? setCanSubmit(true)
      : setCanSubmit(false);
  }, []);

  return (
    <div className="analysis-insight-list">
      <div className="insight-modal-header">
        <div className="insight-modal-title">
          {isEdit ? 'Edit' : 'New'} {moduleName}
        </div>
      </div>
      <Form form={insightForm} onChange={onFormChange} autoComplete="off">
        <div className="insight-modal-content">
          <div className="label">title</div>
          <Form.Item name="title" initialValue={defaultValue.title}>
            <Input
              disabled={isLoading}
              maxLength={
                field === 'insight'
                  ? insightModals.INSIGHT_TITLE_LIMIT
                  : insightModals.GUIDING_PRINCIPLE_TITLE_LIMIT
              }
            />
          </Form.Item>
          {shouldHideSummaryIfIsGuidingP ? null : (
            <>
              <div className="label">summary</div>

              <Form.Item name="summary" initialValue={defaultValue.summary}>
                <InsightTextarea
                  disabled={isLoading}
                  maxLength={insightModals.INSIGHT_SUMMARY_LIMIT}
                />
              </Form.Item>
            </>
          )}
          <div className="label">
            {shouldHideSummaryIfIsGuidingP ? 'description' : moduleName}
          </div>
          <Form.Item
            name={field}
            className="insight-textarea"
            initialValue={defaultValue[field]}
          >
            <InsightTextarea
              disabled={isLoading}
              maxLength={insightModals.INSIGHT_LIMIT}
            />
          </Form.Item>
        </div>
        <div className="action-wrapper">
          <Button
            isLoading={isLoading}
            kind="secondary"
            size="lg"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            isLoading={isLoading}
            size="lg"
            onClick={submitForm}
            disabled={canSubmit}
          >
            Publish
          </Button>
        </div>
      </Form>
    </div>
  );
}

// InsightForm.propTypes = {};

export default memo(InsightForm);
